import styled from 'styled-components';

export const SheetFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: env(safe-area-inset-bottom);

  .ant-btn {
    height: 44px;
  }
`;

export const SheetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-select {
    width: 100%;
    min-height: 44px;
  }

  .ant-input-number-input {
    height: 42px;
  }
`;

export const FieldLabel = styled.div`
  margin-bottom: 6px;
  font-size: 13px;
  color: #595959;
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;

  > * {
    flex: 1;
    min-width: 0;
  }
`;

export const ErrorText = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: #ff4d4f;
`;
